// extracted by css-extract-rspack-plugin
export default {"PromptsGrid":"OnboardingPrompts-module__PromptsGrid__DVznV","PromptItem":"OnboardingPrompts-module__PromptItem__uyek4","Prompt":"OnboardingPrompts-module__Prompt__cm8pw"};